exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_cartItems__IiRpf {\n  width: 100%;\n}\n\n.styles_cartItems__IiRpf [class*=\"card-content-padding\"] {\n  padding-bottom: 0px;\n}\n\n.styles_empty__qbLxH {\n  display: flex !important;\n  flex-direction: column;\n  justify-content: center !important;\n  align-items: center;\n  flex: 1 1 !important;\n  height: 100%;\n  font-size: 1rem;\n  font-weight: bold;\n  color: var(--f7-theme-color);\n}\n\n.styles_empty__qbLxH i {\n  font-size: 5rem;\n}", ""]);

// Exports
exports.locals = {
	"cartItems": "styles_cartItems__IiRpf",
	"empty": "styles_empty__qbLxH"
};